import { render, staticRenderFns } from "./aParameterSwitch.vue?vue&type=template&id=e70fa62e&scoped=true&"
import script from "./aParameterSwitch.vue?vue&type=script&lang=js&"
export * from "./aParameterSwitch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e70fa62e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VSwitch})
